import { render, staticRenderFns } from "./uploadImageComponent.vue?vue&type=template&id=28f6c2ff&scoped=true"
import script from "./uploadImageComponent.vue?vue&type=script&lang=js"
export * from "./uploadImageComponent.vue?vue&type=script&lang=js"
import style0 from "./uploadImageComponent.vue?vue&type=style&index=0&id=28f6c2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6c2ff",
  null
  
)

export default component.exports